export const STEPS = {
    0: {
        title: 'Personal details',
        desc: 'Personal details such as name and job title are essential in a resume to give the recruiter a quick overview of the candidate.'
    },
    1: {
        title: 'Contact information',
        desc: ''
    }
}

/**
 * Firstname 5
 * Lastname 5
 * Email 5
 * Phone number 5
 * Linkedin profile 5
 * Experience 20
 * Education 20
 * Summary 10
 * Total: 75
 */
export const calculateProgress = (params) => {
    const { firstName, lastName, education, experience } = params;
    let progress = 0;

    if (firstName.length > 0) {
        progress += 5;
    }
    if (lastName.length > 0) {
        progress += 5;
    }

    if (education.length > 0) {
        progress += 20;
    }
    if (experience.length > 0) {
        progress += 20;
    }

    return progress;
}

export const DEFAULT_PARAMS = {
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    title: '',
    dateOfBirth: '',
    nationality: '',
    address: '',
    city: '',
    state: '',
    zipcode: '',
    country: '',
    skills: [],
    education: [{
        universityName: "",
        degreeName: "",
        courseName: "",
        startDate: { month: "", year: "" },
        location: "",
        endDate: { month: "", year: "" },
    }],
    experience: [{
        companyName: "",
        jobPosition: "",
        startDate: { month: "", year: "" },
        endDate: { month: "", year: "" },
        isPresent: false,
        description: "",
        location: "",
    }],
    design: {
        style: 'bentz',
        layout: 'left',
    },
    languages: [{ name: 'English', proficiency: '' }],
}